import * as types from "@/store/constants/types";
export default {
  [types.LITE_SEARCH_POP_SHOW](state: any, payLoad: any) {
    state.liteSearchShow = payLoad;
  },
  [types.VIP_RETAIN_DIALOG_CHANGE](state: any, payLoad: any) {
    state.retainDialogShow = payLoad;
  }
};
